import _ from "lodash";
import { useMemo } from "react";
import { useSelector, shallowEqual } from "react-redux";
import { createSelector } from "@reduxjs/toolkit";

export const makeUseMembersForGroup = () =>
	createSelector(
		(state) => state.members.items,
		(state, groupId) => groupId || _.get(state, "quiddity.item.group.id"),
		(members, groupId) =>
			members
				.filter((member) => member.group === groupId)
				.map((member) => member.id)
	);

export const useMembersForGroup = ({ id, groupId } = {}) => {
	const makedMembersForGroup = useMemo(makeUseMembersForGroup, []);
	// console.log("makedMembersForGroup recomputations", makedMembersForGroup.recomputations());
	return useSelector(
		(state) => makedMembersForGroup(state, id || groupId),
		shallowEqual
	);
};
